import { Injectable } from '@angular/core';
import { IID_GR_TASKS } from '@common/interfaces/interfaceData';
import { Topics } from '@common/interfaces/topics';
import { ActionService } from '../action/action.service';
import { CrudService } from '../crudService';
import { ProjectEntityStoreStrategy } from '../updateStoreStrategies';
import { IIDGrTasksQuery } from './iidGRTasks.query';
import { IIDGrTasksStore } from './iidGRTasks.store';
import { InterfaceDataService } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataService(InterfaceName.GR_TASKS)
export class IIDGrTasksService extends CrudService<IID_GR_TASKS, IIDGrTasksStore, IIDGrTasksQuery> {

  constructor(
    protected store: IIDGrTasksStore,
    public query: IIDGrTasksQuery,
    protected actionService: ActionService,
    protected updateStrategy: ProjectEntityStoreStrategy,
  ) {
    super(
      Topics.IID_GR_TASKS,
      store,
      query,
      actionService,
      updateStrategy
    );
  }

}
